import { compose, createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';

import { rootReducer, whiteList } from './reducers';

const persistConfig = {
  key: 'root',
  storage: storageSession,
  whitelist: whiteList,
};

// Only use the dev tool in dev environment, import compose and wrap applyMiddleware(reduxThunk) with composeEnhancers
const composeEnhancers =
  ((window as any)['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose) ||
  compose;
const pReducer = persistReducer<any>(persistConfig, rootReducer);

export const store = createStore(
  pReducer,
  composeEnhancers(applyMiddleware(reduxThunk)),
);
export const persistor = persistStore(store);
